'use client';

import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from 'react-hook-form';

import { LEGAL_ROUTES } from '@/constants/routes';

type MarketingConsentCheckboxProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  error?: string;
};

export function MarketingConsentCheckbox<T extends FieldValues>({
  name,
  control,
  error,
}: MarketingConsentCheckboxProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const checkboxId = `form-field-${String(name)}`;

        return (
          <div className="flex flex-col gap-1">
            <div className="flex items-start gap-2">
              <input
                ref={field.ref}
                id={checkboxId}
                name={field.name}
                type="checkbox"
                checked={field.value === true}
                onChange={(event) => field.onChange(event.target.checked)}
                onBlur={field.onBlur}
                className="accent-royal-500 focus-visible:outline-royal-500 mt-2 size-4 shrink-0 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2"
              />
              <div>
                <label
                  htmlFor={checkboxId}
                  className="cursor-pointer text-xs leading-5 text-gray-700"
                >
                  Keep me updated. I would like to receive news, offers, and
                  event invitations from LIPS Healthcare by email.
                </label>

                <p className="mt-1 text-[10px] leading-4 text-gray-600">
                  You can withdraw consent at any time. See our{' '}
                  <a
                    href={LEGAL_ROUTES.PRIVACY_POLICY}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-royal-500 focus-visible:outline-royal-500 font-semibold underline underline-offset-2 focus-visible:outline-2 focus-visible:outline-offset-2"
                  >
                    privacy policy
                  </a>{' '}
                  for how we handle your information.
                </p>
              </div>
            </div>

            {error && (
              <span className="pl-7 text-[10px] text-red-500">{error}</span>
            )}
          </div>
        );
      }}
    />
  );
}
